/**
 * #2485: what the "skyData could not check the connection" card adds for a SQL Server source it
 * did not reach. The server and port come from the form, on screen only (the browser never sends
 * them anywhere and the server never logs them). No outbound address is named: a SQL source may
 * be private and leave by a route other than the environment's public address, so the card keeps
 * "Ask Skypoint for that address." and gives the network team a reference id instead.
 */

/** The hub codes of a SQL Server source skyData did not get to (`sqlReachMessage`). */
const REACH_CODES: ReadonlySet<string> = new Set([
  "TIMEOUT",
  "HOST_UNREACHABLE",
  "CONNECTION_REFUSED",
]);

/** True when the answer is a SQL Server source that was not reached, which the card details. */
export function isReachFailure(
  connectorName: string,
  errorCode: string | null | undefined,
): boolean {
  return (
    connectorName === "sqlserver" && typeof errorCode === "string" && REACH_CODES.has(errorCode)
  );
}

export interface ReachDetailLine {
  label: string;
  value: string;
}

/**
 * The lines the card shows and Copy details copies. A line with no value is left out, so a Viewer
 * (whose server reads withheld, #1107) or a named instance (no port) never gets an empty one.
 */
export function reachDetailLines(input: {
  server: string | null;
  port: string | null;
  time: string | null;
  reference: string | null;
}): ReachDetailLine[] {
  const lines: ReachDetailLine[] = [];
  if (input.server) lines.push({ label: "Server", value: input.server });
  if (input.port) lines.push({ label: "Port", value: input.port });
  if (input.time) lines.push({ label: "Time", value: input.time });
  if (input.reference) lines.push({ label: "Reference", value: input.reference });
  return lines;
}

/** The text Copy details puts on the clipboard. */
export function reachDetailsText(lines: readonly ReachDetailLine[]): string {
  return lines.map((line) => `${line.label}: ${line.value}`).join("\n");
}
